// const mediaQueryLandscape = window.matchMedia('(min-width: 375px)')
import $ from 'jquery'

const userAgent = navigator.userAgent.toLowerCase()
export default class Screen {
  // Check device
  get isPC() {
    const mq = window.matchMedia('screen and (min-width: 897px)')
    return mq.matches
  }

  get isTablet() {
    return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
      userAgent
    )
  }

  size() {
    const mq = window.matchMedia('screen and (min-width: 897px)')
    $(mq).on('change', () => {
      $(window).trigger('breakpointChange')
    })
  }
}
